var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1826 108C33.7151 108 12.1826 86.4675 12.1826 60C12.1826 33.5325 33.7151 12 60.1826 12C86.6501 12 108.183 33.5325 108.183 60C108.183 86.4675 86.6501 108 60.1826 108ZM60.1826 18C37.0226 18 18.1826 36.84 18.1826 60C18.1826 83.16 37.0226 102 60.1826 102C83.3426 102 102.183 83.16 102.183 60C102.183 36.84 83.3426 18 60.1826 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 60H54V84H66V60Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54C64.9706 54 69 49.9706 69 45C69 40.0294 64.9706 36 60 36C55.0294 36 51 40.0294 51 45C51 49.9706 55.0294 54 60 54Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.9d8f72c7.svg";
export { ForwardRef as ReactComponent };